<template>
  <div class="lightbox" @click="close">
    <div class="lightbox__overlay">
      <button class="lightbox__close" @click="close">
        <svg viewBox="0 0 32 32" preserveAspectRatio="xMidYMid meet" focusable="false" style="pointer-events: none; display: block; width: 100%; height: 100%;"><g>
          <path d="M25.333 8.547l-1.88-1.88-7.453 7.453-7.453-7.453-1.88 1.88 7.453 7.453-7.453 7.453 1.88 1.88 7.453-7.453 7.453 7.453 1.88-1.88-7.453-7.453z"></path>
        </g></svg>
      </button>
    </div>
    <div class="lightbox__content">
      <img
        class="lightbox__image"
        :src="imageUrl"
        alt="lightbox"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { E_LIGHTBOX_EVENT } from '../../types/components-events.enums';
import type { TLightboxEventResponse } from '../../types/event-response.types';

interface IProps {
  imageUrl: string;
}
defineProps<IProps>();

const emit = defineEmits<{
  (event: E_LIGHTBOX_EVENT.CLOSE, payload: TLightboxEventResponse[E_LIGHTBOX_EVENT.CLOSE]): TLightboxEventResponse;
}>();

function close() {
  emit(E_LIGHTBOX_EVENT.CLOSE);
}
</script>

<style scoped lang="scss">
.lightbox {
  z-index: 100000;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(255, 255, 255, 0.8);
  cursor: zoom-out;

  &__overlay {
    position: absolute;
    top: 5px;
    right: 5px;
  }

  &__close {
    border: none;
    background: none;
    cursor: pointer;
    width: 50px;
    height: 50px;
  }

  &__content {
    display: flex;
    align-items: center;
    justify-content: center;
    max-width: 800px;
    max-height: 800px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, .2);
  }

  &__image {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
}
</style>